<template>
	<div>
		<Header />
		<Carousel loop :height="350" arrow="never" dots="none">
			<CarouselItem>
				<div class="banner">
					<div>
						<p class="pageType">关于我们</p>
					</div>
				</div>
			</CarouselItem>
		</Carousel>
		<div class="mainContent">
			<div>
				<p class="title">公司概况</p>
				<div class="companyProfile">
					<img src="../../assets/img/aboutUs/banner.png" />
					<div>
						<p>科技赋能，智慧引领</p>
						<p style="margin-top: 30px;margin-left: 20px;">高效、安全、可靠</p>
					</div>
					<div class="briefIntroduction">
						<p>安徽亿众数科数字科技有限公司</p>
						<div>
							<p>
								安徽亿众数科数字科技有限公司系安徽亿众投资管理有限公司子公司，是安徽省数据交易所认证的“数据经纪服务商”，“数据咨询服务商”，“数据资产评估服务商”是一家以AI算法驱动的数据要素服务机构和企业股权价值服务机构。为地方国资平台在城市运营、产业发展、数字转型、数据资源整合、投融资等方面提供综合解决方案和资本市场规划咨询。已助力省内多家农业、工业制造业、教育、行政机关单位、金融机构、商业流通等企业，提供基于大数据、人工智能、区块链技术的技术研发和技术服务。帮助实现数据要素流通、数据估值、提供数据要素供需方撮合服务、数据交易相关的代理代销。主旨通过数字科技和专业咨询服务解决政府和企业的数据资源整合、价值提升、数据资产入表及证券化等方面的问题。
							</p>
							<p>
								安徽亿众亦是安徽省股权托管交易中心AA类推荐商会员单位（编号A—0033）
								，累计服务企业已超过2000家旨在为企业提供挂牌上市、项目申报、企业管理咨询及财务信息咨询等综合性服务，自成立以来连续多年获得安徽股权中心颁发的“最佳AA类推荐机构”，“最佳股改机构”奖。
							</p>
						</div>
						<ul>
							<li>
								<i>01</i>
								<p>
									<i class="iconfont icon-kehu2"></i>
									<span>稳健经营</span>
								</p>
							</li>
							<li>
								<i>02</i>
								<p>
									<i class="iconfont icon-chuangxinchanpin"></i>
									<span>创新管理</span>
								</p>
							</li>
							<li>
								<i>03</i>
								<p>
									<i class="iconfont icon-hezuo"></i>
									<span>共赢未来</span>
								</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div>
				<p class="title">荣誉资质</p>
				<ul class="honor">
					<li>
						<img src="../../assets/img/aboutUs/certificate2018.png" alt="2018年会员荣誉证书" />
						<p>2018年会员荣誉证书</p>
					</li>
					<li>
						<img src="../../assets/img/aboutUs/certificate2019.png" alt="2019年最佳会员证书" />
						<p>2019年最佳会员证书</p>
					</li>
					<li>
						<img src="../../assets/img/aboutUs/certificate2020.png" alt="2020年最佳会员证书" />
						<p>2020年最佳会员证书</p>
					</li>
					<li>
						<img src="../../assets/img/aboutUs/certificate2022.png" alt="2022年度股改质量奖" />
						<p>2022年度股改质量奖</p>
					</li>
					<li>
						<img src="../../assets/img/aboutUs/certificate2023.png" alt="2023年度最佳推荐商会员" />
						<p>2023年度最佳推荐商会员</p>
					</li>
					<li>
						<img src="../../assets/img/aboutUs/quotientCertificate.png" alt="数商证书" />
						<p>数商证书</p>
					</li>
				</ul>
			</div>

		</div>


		<ContactUs />
		<Footer />
	</div>
</template>

<script>
	import Header from '@/common/header'
	import Footer from '@/common/footer.vue'
	import ContactUs from '@/common/contactUs.vue'

	export default {
		components: {
			Header,
			Footer,
			ContactUs

		},
		data() {
			return {



			}
		},
		mounted() {

		},
		methods: {


		}


	}
</script>

<style scoped lang="less">
	.banner {
		background: url(../../assets/img/aboutUs/banner.png) center center no-repeat
	}

	.title {
		font-size: 28px;
		font-weight: bold;
		color: #282828;
		text-align: center;
		margin-top: 49px;
		margin-bottom: 30px;
		padding-bottom: 10px;
		position: relative;
	}

	.title::after {
		content: '';
		display: block;
		width: 66px;
		height: 4px;
		background: var(--mainColor);
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
	}

	.companyProfile {
		display: flex;
		justify-content: space-between;
		position: relative;

		>img {
			width: 260px;
			height: 471px;
			object-fit: cover;
		}

		>div:nth-of-type(1) {
			position: absolute;
			left: 230px;
			top: 140px;

			p {
				width: 200px;
				padding-bottom: 7px;
				border-bottom: 4px solid #000;
				text-align: center;
				font-size: 20px;
				font-weight: bold;
				color: #282828;
			}
		}

		.briefIntroduction {
			width: 810px;
			height: 471px;
			background: #F5F7FA;
			box-shadow: 2px 2px 13px 0px rgba(156, 5, 5, 0.17);
			border: 2px solid #FFFFFF;
			padding: 30px 30px 30px 90px;

			>p {
				font-size: 20px;
				font-weight: bold;
				color: var(--mainColor);
			}

			>div p {
				font-size: 14px;
				color: #282828;
				text-indent: 2em;
				line-height: 26px;
				margin-top: 10px;
			}

			ul {
				display: flex;
				justify-content: space-between;
				margin-top: 24px;

				li {
					width: 216px;
					height: 80px;
					background: #EFF1F4;
					position: relative;
					display: flex;
					align-items: center;

					>i {
						font-size: 70px;
						font-weight: bold;
						color: #E2E2E2;
						position: absolute;
						top: -9px;
						right: 7px;
					}

					p {
						position: relative;
						z-index: 2;

						i {
							font-size: 29px;
							color: var(--mainColor);
							margin-left: 33px;
						}

						span {
							font-size: 18px;
							color: #282828;
							margin-left: 10px;
						}
					}

				}
			}

		}

	}

	.honor {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;

		li {
			width: 381px;
			background: #FFFFFF;
			box-shadow: 2px 2px 13px 0px rgba(156, 5, 5, 0.17);
			padding: 28px 18px;
			text-align: center;
			margin-bottom: 28px;


			p {
				font-size: 14px;
				color: #282828;
				margin-top: 18px;
			}

		}
	}
</style>